import { getAvatarImage, getAvatarIndex } from '@/lib/utils/avatar.utils'
import { Box, HStack, Image, Text} from '@chakra-ui/react'

interface UserProfileSectionProps {
  userAddress: string
  userName?: string
  avatarUrl?: string
}

export function UserProfileSection({ userAddress, userName }: UserProfileSectionProps) {
  // Generate a default username from address if not provided
  const displayName = userName || `User ${userAddress.slice(0, 6)}...${userAddress.slice(-4)}`

  return (
    <HStack align="center" gap={2.5} px={4} py={2} bg="white/8">
      {/* Avatar */}
      <Image
        h={5}
        w={5}
        rounded="full"
        src={getAvatarImage(getAvatarIndex(userAddress))?.src}
      />

      {/* User Info */}
      <Box flex={1} className="flex-1">
        <Text fontSize="md" color="text.t1/90" fontWeight="medium">{displayName}</Text>
      </Box>
    </HStack>
  )
}
